import styles from './SecondaryControls.module.scss';
import GenericButton from '../generic-button/GenericButton';
import { DownloadIcon, EmailIcon, PrintIcon } from '../icons/Icons';
import React from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import SecondaryDistanceSelect from './secondary-distance-select/SecondaryDistanceSelect';

const SecondaryControls = (props: any) => {

  return (
    <div className={styles.secondaryControlContainer}>
      {/* <SecondaryDistanceSelect /> */}
      <GenericButton buttonText={'Download Provider Directory'} handleClick={() => redirectProviderDirectory(props)}>
  <DownloadIcon/>
   </GenericButton>
            <GenericButton buttonText={'Download Pharmacy Directory Page'} handleClick={() => downloadRedirect(props)}>
        <DownloadIcon/>
      </GenericButton>
      <GenericButton buttonText={'Email'} handleClick={() => props.setShowEmailField(!props.showEmailField)}>
        <EmailIcon/>
      </GenericButton>
    </div>
  );
};

const redirectProviderDirectory = (passedProps: any) => {
 const confirmed = window.confirm('Please navigate to Providers section in the following page to download!');
    // Check if user confirmed
    if (confirmed) {
      window.location.href= "/providers/provider-documents/";
    } 
};



const downloadRedirect = (passedProps: any) => {
  const { planCode } = passedProps.match.params;
  passedProps.history.push(`/download/${planCode}`);
  if (passedProps.history.location.pathname.includes('/download')) {
    window.location.reload();
  };
};

const downloadPdf = (pdfName: string, heightModifier: number, pdfContainerId: string, packageForEmail?: boolean, email?: string) => {
  const input = document.getElementById(pdfContainerId);
  html2canvas(input as HTMLElement)
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'pt', 'a4');
      const height = 500 + heightModifier;
      console.log(height);
      pdf.addImage(imgData, 'PNG', 0, 0, 600, height);
      // pdf.output('dataurlnewwindow');
      if(!packageForEmail) {
        pdf.save(`${pdfName}.pdf`);
      } else {
        axios.post(`/SendEmail`, {
          planTitle: window.location.host.split('.')[0],
          planBase: window.location.host === 'localhost:3000' ? 'alignseniorcare.com' : window.location.host,
          fileAttachment: btoa(pdf.output()),
          fileName: pdfName,
          userEmail: email
        }).then(res => {
          console.log(res)
        }).catch(err => {
          console.error(err);
        })
      }
    });
}

export default withRouter(SecondaryControls);
 